const ko = {
  switchOrg: '조직 전환이 성공했습니다! 페이지를 새로 고칩니다...',
  userInfo: '개인정보',
  preferences: '시스템 설정',
  logout: '로그아웃',
  invnManag: '창고 관리',
  orgHouse: '조직 창고',
  orderList: '주문 목록',
  invnHistory: '역사 목록',
  salesMana: "영업 관리",
  customMana: "터미널 고객 관리",
  priceMana: "가격 관리",
  orderMana: "주문 관리",
  orgManag: '조직 관리',
  bomMana: 'BOM 관리',
  memberManag: '회원 관리',
  enableMember: '멤버 활성화',
  disableMember: '멤버 비활성화',
  categoryManag: '제품 카테고리 관리',
  productList: '제품 목록',
  APPManagement: 'APP관리',
  productData: '생산 데이터 입력',
  orderReviews: '주문 리뷰',
  productionInfo: '생산 자료 제작',
  dataModule: '데이터 모듈',
  orderReport: '주문 보고서',
  conLogout: '로그아웃하시겠습니까? ',
  conLogoutTip1: '로그아웃을 확인하시면 로그인 페이지로 돌아갑니다. ',
  loggingOut: '로그아웃 중입니다...',
  selectOrg: '조직을 선택하세요',
  themeColor: '테마 색상',
  addSuccess: '성공적으로 추가되었습니다',
  addFailed: '추가 실패',
  updateSuccess: '업데이트 성공',
  updateFailed: '업데이트 실패',
  validaFailed: '검증 실패',
  cancel: '취소',
  confirm: '확인',
  Loading: '로딩중',
  upFail: '업로드 실패',
  plTryAgain: '나중에 다시 시도해주세요',
  changeTip: '언어 설정',
  switchOrgFailTip1: '현재 조직에는 권한이 없으므로 전환할 수 없습니다! ',
  switchOrgFailTip2: '조직 전환에 실패했습니다. 다시 시도하세요! ',
  loginFailTip1: '해당 계정은 백엔드 관리자가 아닙니다. 사용자 로그인으로 돌아가세요. ',
  loginFailTip2: '이 계정은 조직의 구성원이 아니거나 권한이 없습니다. 관리자에게 문의하세요. ',
  userAbnormalTip: '사용자 상태가 비정상이거나 권한이 부족합니다. 관리자에게 문의하거나 다시 로그인하세요! ',
  orderProductionReports: '주문 생산 보고서',
  orderReview: '주문 리뷰',
  orderProductionData: '주문 생산 데이터',
  purchaseMana: '구매 관리',
  supplierMana: '공급업체 관리',
  materialControl: '소재 관리',
  requirementList: '요구사항 목록',
  noPassRequirement: '승인되지 않은 요구 사항 목록',
  passedRequirement: '승인된 요구 사항 목록',
  prod: '생산',
  finance: '금융',
  generatePurOrder: '구매 주문 생성',
  isAdmin: '당신은 시스템 관리자입니까?',

  okOrder: '공식 판매 주문',
  saleOrderFinish: '판매 주문 완결',
  waitOk: '요구사항 검토',
  noPass: '검토 보류 중',
  passed: '요구 사항이 검토되었습니다',
  purOrder: '구매 주문 관리',
  orderRe: '판매 리뷰 양식',
  disableAndEnable: '비활성화/활성화',
  memberOperation: '멤버 작업',
  merchandiseEditor: '상품 편집자',
  subcategoryEditing: '하위 카테고리 편집',
  orgOperation: '조직 운영',
  reject: '요청 반환',
  orgMana: "조직 관리",
  orgInfoUpdate: "조직 정보 수정",
  orgMemberUpdate: "조직 구성원 수정",
  wareMana: "창고 관리",
  inboundMana: "인바운드 관리",
  outboundMana: "아웃바운드 관리",
  inventoryMana: "재고 관리",
  orderTrack: '주문 추적',
  pendingOrder: '완료되지 않음',
  doneOrder: '완료',
  closeOrder: '닫힘',
  mcDataMt: '재료 관리 데이터 유지 관리',
  mcReTemp: '자재 관리 요구 사항 템플릿',
  orderEntry: '주문 데이터 입력',
  orderProdMt: '생산 데이터 유지 관리',
  purPendingPay: '아직 주문이 없습니다',
  purPayed: '주문 완료',
  purDone: '완료',
  purOrderMt: '구매 정보 유지',
  requirementPurchase: '요구매서 작성',
  reqM: '자재 준비 계획',
  DATAManage: "데이터 관리",
  QutationManage: '질문서 관리',
  typeManage: '상품 유형 관리',
  submit: '저장',
  gategoryManage: '견적 품목 목록',
  printSetting: '인쇄 설정',
  quotationManage: '견적 관리',
  setExchange: '환율 설정',
  mainCurrency: '본위화폐',
  company: '회사 이름',
  address: '회사 주소',
  plzCompany: '회사 이름을 입력하십시오',
  plzAddress: '회사 주소를 입력하십시오',
  orderManage: '주문 관리',
  warehousePreparation: '입출고 준비',
  warehouseManagement: '입출고 관리',
  operationStatus: '작업 상태',
  locationManagement: '위치 관리',
  commodity: '제품 관리',
  upSucc: "파일 업로드 성공",
  addressM: "배송 주소 관리",
  addAddress: "주소 추가",
  editAddress: "주소 수정",
  inventoryManage: "재고 관리",
  purchaseOperation: '구매 운영',
  manualQuotation: '수동 견적',
  materialTracking: '자재 추적',
  returnAndExchange: '반품 및 교환',
  pleaseFillRate: '환율을 입력하십시오',
  uploadImage: '이미지 업로드',
  pleaseEnterName: '이름을 입력하십시오',
  pleaseEnterAddress: '주소를 입력하십시오',
  orderReportAll: '주문 보고서_전체',
  // 공급업체 관리
  disabledSupplier: '비활성화된 공급업체',
  confirmDisableSupplier: '비활성화 하시겠습니까?',
  confirmDisableSupplierDesc: '이 공급업체를 비활성화합니다',
  confirmEnableSupplier: '활성화 하시겠습니까?',
  confirmEnableSupplierDesc: '이 공급업체를 활성화합니다',


  // Reimburse
  reimburseMana: '신청 승인',
  myApplication: '내 신청',
  pendingApproval: '내 승인 대기',
  allApplications: '전체 신청',
  inOutDetail: '입출고 상세',
  locationRefProducts: '위치 상품 관계',
  priceList: "구매 가격 목록",
  inventoryAlert: "재고 경고",
  setInventoryAlert: "재고 경고 추가",
  purchaseRule: "구매 조항",
  addPurchaseRule: "구매 조항 추가",
  ruleLangsPl: "추가할 구매 조항의 언어 버전을 선택하세요 (원하는 언어가 없으면 시스템 설정에서 추가하세요)",
  printRule: "조항 추가",
  notPrintRule: "조항 추가 안 함",
  noRuleConfig: "모든 언어에 대해 구매 조항이 입력되지 않았습니다. 구매 조항을 인쇄하려면 시스템 설정에서 완료하세요.",
  purchaseRuleSet: "구매 조항 설정",
  factoryInventory: "생산라인 창고",
  equipmentManagement: "장비 관리",
  width: "용지 너비 (세로 연속)",
  height: "용지 높이 (세로 연속)",
  printTip: "시스템 인쇄 용지 설정: {{width}}mm X {{height}}mm",
  printTipVertical: "세로 연속 인쇄 용지 설정 (너비 X 높이)",
  purInvItem: "납품서 상세",
  locInvDetail: "로케이션 입출고 상세",
};

export default ko;
